import React, { useMemo } from 'react';
import classnames from 'classnames';
import { observer, inject } from 'mobx-react';
import { FontSizes, FontWeights, mergeStyleSets, mergeStyles } from '@fluentui/react';

import SalesforceLogo from 'assets/images/salesforce-logo.svg';
import ZohoLogo from 'assets/images/zoho-logo.svg';
import SignIn from "@v2/views/SignIn/SignIn";

const classNames = mergeStyleSets({
  root: {
    margin: '16px',
  },
  source: {
    width: '100%',
    height: '120px',
    marginBottom: '16px',
    border: 'none',
    position: 'relative',
    cursor: 'pointer',
    selectors: {
      ':hover': {
        opacity: 0.8,
      },
      '.user-info': {
        position: 'absolute',
        right: '10px',
        bottom: '10px',

        background: '#eeea',
        padding: '2px 4px',
        borderRadius: '2px',
        border: '1px solid #eee',

        fontSize: FontSizes.small,
      },
      '.active-status': {
        position: 'absolute',
        top: '10px',
        left: '10px',

        background: 'white',
        padding: '4px 6px',
        borderRadius: '4px',

        fontSize: FontSizes.small,
      },
      '.coming-soon': {
        position: 'absolute',
        transform: 'translateY(-50%)',
        left: '0px',
        right: '0px',
        top: '50%',

        padding: '8px',
        background: '#eeed',
        fontWeight: FontWeights.bold,
      },
    },
  }
});


function  Sources({ uesrStore }) {
  return <SignIn/>
}


const Sources2 = ({ userStore }) => {
  const sources = [
    { logo: SalesforceLogo, bgColor: '#D2EFEA', isActive: true, userName: userStore.userName, onClick: () => {} },
    { logo: ZohoLogo, bgColor: '#F4F4F4', isComingSoon: true, }
  ];

  return (
    <div className={classNames.root}>
      { sources.map((source, index) => <Source key={index} {...source} />) }
    </div>
  );
}

const Source = ({ logo, bgColor, isActive, userName, isComingSoon, onClick }) => {
  // const imageStyle = useMemo(() => mergeStyles({ filter: `grayscale(100%)` }), [isComingSoon]);
  const bgStyle = useMemo(() => mergeStyles({ background: bgColor }), [bgColor]);

  return (
    <button className={classnames(classNames.source, bgStyle)} onClick={onClick}>
      <img src={logo}/>
      { isComingSoon && <span className="coming-soon">Coming Soon!</span> }
      {!isComingSoon && <span className="user-info">{userName || 'Logged Out'}</span> }
      { isActive && <span className="active-status">Active</span> }
    </button>
  );
}

export default inject('userStore')(observer(Sources));
